var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoDrop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.573,
    height: 53.045,
    viewBox: "0 0 73.573 53.045",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208",
    transform: "translate(-1565.541 7476.471)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-videocam",
    "data-name": "Icon ionic-ios-videocam",
    transform: "translate(1574.294 -7468.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M38.6,10.8a2.386,2.386,0,0,0-1.3.377L25.224,18.8a1.2,1.2,0,0,0-.559,1.006V30.423a1.2,1.2,0,0,0,.559,1.006l12.081,7.626a2.51,2.51,0,0,0,1.3.377h2.9a1.189,1.189,0,0,0,1.2-1.187V11.987a1.2,1.2,0,0,0-1.2-1.187Z",
    transform: "translate(22.11 1.775)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M35.979,44.754H9.443A7.216,7.216,0,0,1,2.25,37.576v-21.4A7.2,7.2,0,0,1,9.429,9H35.965a7.2,7.2,0,0,1,7.179,7.179V37.562a7.186,7.186,0,0,1-7.165,7.192Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-plus-circle",
    "data-name": "Icon feather-plus-circle",
    transform: "translate(1565.541 -7476.47)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M25,14a11.119,11.119,0,0,1-4.3,8.725A10.759,10.759,0,0,1,14,25,11,11,0,1,1,25,14Z",
    transform: "translate(-3 -3)",
    fill: "#7315ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M18,12v8.8",
    transform: "translate(-6.997 -5.399)",
    fill: "#7315ce",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M12,18h8.8",
    transform: "translate(-5.398 -6.998)",
    fill: "#7315ce",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoDrop);
export default __webpack_public_path__ + "static/media/video_drop.6b233ba889fda98ea7dcfb10ba351684.svg";
export { ForwardRef as ReactComponent };